// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3apd6","left":"styles_left__1Qu8y","desktopActions":"styles_desktopActions__1Rvqi","title":"styles_title__FY-eV"};